/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_BasicInputs */

const en_tab_basic = /** @type {(inputs: Tab_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic`)
};

const es_tab_basic = /** @type {(inputs: Tab_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basico`)
};

/**
* | output |
* | --- |
* | "Basic" |
*
* @param {Tab_BasicInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tab_basic = /** @type {((inputs?: Tab_BasicInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_BasicInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_basic(inputs)
	return es_tab_basic(inputs)
});